(function($) {

  $(document).ready(function() {
    collection.init();
  });

  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }


  var collection = {
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();



    },


    /* --------------------------------------------------------- */
    /* Review */
    initReview: function() {

        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

    },

    /* Hide Dropdown */
    initToggle: function(){

    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {

    },

    fillterTagEvents: function() {

      $( "body" ).delegate( '.filter-tag a:not(".clear"), .filter-tag label', 'click',function(e) {
          $(this).toggleClass('active-checked');
        var currentTags = [];

        if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        }

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
            var otherTag = $(this).parents('.filter-tag').find("input:checked");
            if (otherTag.length > 0) {
                var tagName = otherTag.val();
                if (tagName) {
                  var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    }
                }
            }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
            } else {
                currentTags.push(tagName);
            }
        }
        if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
        } else {
            delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClearAll: function() {
      //clear all selection
        $("body").delegate( 'click','.refined-widgets a.clear-all', function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.q;
            collection.filterAjaxClick();
            e.preventDefault();
        });

         $("body").delegate( '.filter-block .clear', 'click', function(e) {
              var currentTags = [];
              var filterTag = $(this).parent().parent();
              if (Shopify.queryParams.constraint) {
                  currentTags = Shopify.queryParams.constraint.split('+');
              }
              filterTag.find("input:checked").each(function() {
                  var selectedTag = $(this);
                  var tagName = selectedTag.val();
                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                      if (tagPos >= 0) {
                        //remove tag
                          currentTags.splice(tagPos, 1);
                      }
                  }
              });
              filterTag.find("a").each(function() {
                  $(this).removeClass("active-checked");
              });
              if (currentTags.length) {
                  Shopify.queryParams.constraint = currentTags.join('+');
              } else {
                  delete Shopify.queryParams.constraint;
              }
              collection.filterAjaxClick();
              e.preventDefault();
          });

    },

    filterMapClear: function() {
        $(".filter-tag").each(function() {
          var filterTag = $(this);
          if (filterTag.find("input:checked").length > 0) {
              //has active tag
              filterTag.find(".clear").show();
          }
        });
    },

    filterParams: function() {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    },

    filterMapEvents: function() {
        collection.fillterTagEvents();
    },

    resetFilter: function() {
        $(".filter-custom .active-checked, .filter-links .active-checked").removeClass("active-checked");
        $(".filter-tag input:checked").attr("checked", false);

        //category
        var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
        if (cat && cat[1]) {
          $(".filter-links a[href='" + cat[0] + "']").addClass("active-checked");
        }
    },

    filterMapData: function(data) {

        var currentList = $(".grid-uniform");


        var productList = $(data).find(".grid-uniform");

        currentList.replaceWith(productList);

        //replace paging
        if ($(".pagination").length > 0) {
          $(".pagination").replaceWith($(data).find(".pagination"));
        };

        $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        collection.filterMapClear();
    },

    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      collection.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {

      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          showPopup('.loading');
        },

        success: function(data) {

          collection.filterMapData(data);

          collection.filterMapClear();
          hidePopup('.loading');
          
          function azirspares_better_equal_elems($elem) {
            $elem.each(function() {
              if ($(this).find('.equal-elem').length) {
                $(this).find('.equal-elem').css({
                  'height': 'auto'
                });
                var _height = 0;
                $(this).find('.equal-elem').each(function() {
                  if (_height < $(this).height()) {
                    _height = $(this).height()
                  }
                });
                $(this).find('.equal-elem').height(_height)
              }
            });
          }

          if ($('.equal-container.better-height').length) {
            azirspares_better_equal_elems($('.equal-container.better-height'));
          }

          if ($('.seller-items').length) {
            azirspares_better_equal_elems($('.seller-items'));
          }

          $(window).resize(function() {
            if ($('.equal-container.better-height').length) {
              azirspares_better_equal_elems($('.equal-container.better-height'));
            }
          });
          
          if ($(".shopify-product-reviews-badge").length > 0) {
            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
          }

        },

        error: function(xhr, text) {
          hidePopup('.loading')
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }

      });
    },



    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {

    },


    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {

    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {

    },

  }

})(jQuery);

(function () {
  if (window.__puMobileSubmenuScrollLoaded) return;
  window.__puMobileSubmenuScrollLoaded = true;

  var media = window.matchMedia('(max-width: 767px)');
  var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var ticking = false;
  var menus = [];

  function findMenus() {
    menus = Array.prototype.slice.call(document.querySelectorAll(
      '#shopify-section-collection-template .pu-top-category-menu, ' +
      '#shopify-section-collection-template .pu-detailing-menu:not(.pu-top-category-menu)'
    ));
  }

  function clearMenu(menu) {
    menu.classList.remove('pu-mobile-scroll-submenu');
    [
      'position', 'top', 'left', 'right', 'zIndex', 'margin', 'padding',
      'background', 'boxShadow', 'transform', 'opacity', 'pointerEvents',
      'transition', 'willChange'
    ].forEach(function (prop) {
      menu.style[prop] = '';
    });
  }

  function mobileMenuTop(menu) {
    var top = 58;
    var selectors = [
      'header',
      '.header',
      '.site-header',
      '.header-mobile',
      '.header-middle',
      '.header-bottom',
      '.header-search',
      '.search-bar',
      'form[action="/search"]'
    ];
    Array.prototype.slice.call(document.querySelectorAll(selectors.join(','))).forEach(function (node) {
      if (!node || node === menu || node.contains(menu) || menu.contains(node)) return;
      var style = window.getComputedStyle(node);
      var rect = node.getBoundingClientRect();
      if (style.display === 'none' || style.visibility === 'hidden') return;
      if (rect.width < 1 || rect.height < 1 || rect.bottom <= 0) return;
      if (rect.top > window.innerHeight * 0.45) return;
      top = Math.max(top, Math.ceil(rect.bottom));
    });
    return top;
  }

  function update() {
    ticking = false;
    if (!menus.length) findMenus();

    var currentY = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
    menus.forEach(function (menu) {
      if (!media.matches) {
        clearMenu(menu);
        return;
      }

      if (!menu.dataset.puOriginalTop) {
        menu.dataset.puOriginalTop = String(menu.getBoundingClientRect().top + currentY);
      }

      var isPast = currentY > Number(menu.dataset.puOriginalTop) + menu.offsetHeight + 12;
      menu.classList.add('pu-mobile-scroll-submenu');

      if (!isPast) {
        clearMenu(menu);
        menu.classList.add('pu-mobile-scroll-submenu');
        menu.style.transform = 'translateY(0)';
        menu.style.opacity = '1';
        return;
      }

      menu.style.position = 'fixed';
      menu.style.top = mobileMenuTop(menu) + 'px';
      menu.style.left = '0';
      menu.style.right = '0';
      menu.style.zIndex = '45';
      menu.style.margin = '0';
      menu.style.padding = '8px 15px 0';
      menu.style.background = 'rgba(255, 255, 255, 0.98)';
      menu.style.transition = 'transform 180ms ease, opacity 180ms ease, box-shadow 180ms ease';
      menu.style.willChange = 'transform';
      menu.style.transform = 'translateY(0)';
      menu.style.opacity = '1';
      menu.style.pointerEvents = 'auto';
      menu.style.boxShadow = '0 8px 18px rgba(20, 30, 45, 0.08)';
    });

    lastScrollY = currentY;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function init() {
    findMenus();
    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function () {
      menus.forEach(function (menu) { delete menu.dataset.puOriginalTop; });
      requestUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
